import { ReactElement, ReactNode } from 'react';
import { Box, DialogBody, DialogFooter, DialogHeader } from '@ff-it/ui';
import { Form, SubmitHandler } from '@ff-it/form';
import type { ActivityType } from 'types';
import { BriefFields } from './BriefFields';
export { BriefFields };
import type { BlockDetails } from 'modules/campaign/block/types';
import { sticky } from '../style.css';
import type { CampaignDetails } from 'modules/campaign/campaign/types';
import { DirtyDialogFormGuard } from 'components/form/DirtyDialogFormGuard';

interface BriefFormProps {
  title: string;
  initialValues: BlockDetails;
  before?: ReactNode;
  children: ReactNode;
  submitHandler: SubmitHandler<BlockDetails & Record<string, unknown>>;
  disabled?: boolean;
  campaign: CampaignDetails;
  type: ActivityType;
}

export function BriefForm({
  title,
  initialValues,
  submitHandler,
  disabled,
  before,
  children,
  campaign,
  type,
}: BriefFormProps): ReactElement {
  const handleSubmit: BriefFormProps['submitHandler'] = (values, form) =>
    // React Final Form omits empty inline arrays; send [] so an empty radio
    // clip list is treated as an explicit deletion.
    submitHandler(values.type === 'RADIO' ? { ...values, radio_clips: values.radio_clips ?? [] } : values, form);

  return (
    <Form onSubmit={handleSubmit} initialValues={initialValues} noValidate disabled={disabled} display="contents">
      <DialogHeader
        title={
          <>
            <strong>{title}</strong> {type}
          </>
        }
      />

      {before}
      <DialogBody>
        <DirtyDialogFormGuard />
        <BriefFields type={type} campaign={campaign} references={initialValues.brief?.references} />
      </DialogBody>
      <Box className={sticky}>
        <DialogFooter>{children}</DialogFooter>
      </Box>
    </Form>
  );
}
